export default "__VITE_ASSET__d5e9f427__"